import Donee from "../../models/Donee";

export interface doneeStateInterface {
  donees: Donee[];
  lastCursor: number | string;
  loading: boolean;
}

const initState: doneeStateInterface = {
  donees: [],
  lastCursor: "",
  loading: false,
};

const doneeReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_DONEE_LIST":
      return {
        ...state,
        donees: action.payload.donees,
        lastCursor: action.payload.lastCursor,
      };
    case "UPDATE_DONEE_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default doneeReducer;
